/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {CanvasRenderConfig as ɵb,CanvasRenderConfigModel as ɵa} from './lib/tokens/canvas-resize-obserer-enable-token';